import "./TestimonialCard.css";

interface TestimonialCardProps {
  name: string;
  city: string;
  projectType: string;
  year: number;
  rating: number;
  quote: string;
}

const TestimonialCard = ({
  name,
  city,
  projectType,
  year,
  rating,
  quote,
}: TestimonialCardProps) => {
  const renderRatingStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i += 1) {
      if (rating >= i) {
        stars.push(<i key={`full-${i}`} className='bi bi-star-fill'></i>);
      } else if (rating >= i - 0.5) {
        stars.push(<i key={`half-${i}`} className='bi bi-star-half'></i>);
      } else {
        stars.push(<i key={`empty-${i}`} className='bi bi-star'></i>);
      }
    }
    return stars;
  };

  const initials = name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className='col-md-4'>
      <div className='card h-100 shadow-sm testimonial-card brand-card'>
        <div className='card-body text-center px-4 py-4'>
          <div className='testimonial-avatar mx-auto mb-3'>{initials}</div>
          <h5 className='card-title mb-1'>{name}</h5>
          <p className='testimonial-meta mb-2'>
            {projectType} &nbsp;·&nbsp; {city} &nbsp;·&nbsp; {year}
          </p>
          <div className='rating mb-3'>
            {renderRatingStars()}
            <span className='rating-value ms-2'>{rating.toFixed(1)}</span>
          </div>
          <p className='card-text testimonial-quote'>"{quote}"</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
